module.exports = __webpack_public_path__ + "static/img/11.ee26ed34.png";